import PropTypes from 'prop-types';
import React, { createContext, useContext, useMemo } from 'react';

import { useSchedule } from './useIntegration';

const ScheduleContext = createContext();

export const useScheduleContext = () => {
  const context = useContext(ScheduleContext);
  if (!context) {
    throw new Error('useScheduleContext must be used within a ScheduleProvider');
  }
  return context;
};

export const ScheduleProvider = ({ children }) => {
  // We use the hook here to manage schedule data and actions.
  // The filters can be adapted based on application-wide context if needed.
  const {
    data: schedule,
    isLoading,
    error,
    addEvent,
    updateEvent,
    deleteEvent,
  } = useSchedule({});

  const value = useMemo(
    () => ({
      schedule,
      isLoading,
      error,
      addEvent,
      updateEvent,
      deleteEvent,
    }),
    [schedule, isLoading, error, addEvent, updateEvent, deleteEvent]
  );

  return <ScheduleContext.Provider value={value}>{children}</ScheduleContext.Provider>;
};

ScheduleProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export default ScheduleProvider;
